export default __webpack_public_path__ + "static/media/img7.bf835617.jpg";